import AsyncView from '@pixelunion/shopify-asyncview';
import rimg from '@pixelunion/rimg-shopify';
import ProductHighlights from '../snippets/ProductHighlights';

export default class StaticProductRecommendations {
  constructor(section) {
    this.section = section;
    this.productHighlights = new ProductHighlights(section.el, section.postMessage);

    const { productId } = section.data;
    const { limit } = section.data.settings;
    const recommendationsEl = section.el.querySelector('[data-product-recommendations]');

    this._loadRecommendations(recommendationsEl, productId, limit);
  }

  onSectionUnload() {
    this.productHighlights.unload();
  }

  _loadRecommendations(container, productId, limit) {
    const url = `${window.Theme.routes.product_recommendations_url}?section_id=static-product-recommendations&limit=${limit}&product_id=${productId}`;

    AsyncView.load(
      url,
      { view: '' },
    ).then(({ html }) => {
      container.innerHTML = html;

      rimg.watch(container);
      this.productHighlights.reload();

      if (window.Shopify && Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }
    });
  }
}
